import moment from 'moment';

import Calllocation from "./calllocation";


 


        class Calltrackingmetrics{
         constructor(params,o){
          this.id = o.id;
          this.accountType = "Calltrackingmetrics";
          this.filter = (o.filter) ? o.filter : false;
          this.permissions = (o.roles) ? o.roles : false;
          
            this._types = {
               "calllocation":Calllocation
            }
            this.generic = {
              name:"",
              id:"",
              platformId:"",
              description:"",
              subTitle:"",
              accountType:"Calltrackingmetrics"
            }
               
               this.setParameters(o);
               

               for (var t of  Object.keys(this._types)){
                if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                  for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                    if (pt.objectIds.indexOf(this.id) > -1){
                      for (var oid of pt.pivotObjectIds){
                        if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                          params.accounts[pt.pivotAccountId][oid].filter = (this.filter) ? this.filter : false;
                          params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                          if (pt.originAccountId == this.id){
                            var acs = params.accounts[pt.pivotAccountId][oid];
                            acs.originId = pt.originId;
                            acs.originAccountId = pt.originAccountId;
                        var model = new this._types[t](params,acs);
                          }
                        if (!model.filtered){
                        this.setModelParameters(model);
                        }
                        }
                      }
                    }
                }
              }
              }
              
      }



                setParameters(params){
                  for (var prop in params){
                      if (params.hasOwnProperty(prop)){
                          var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                          if (this[method]){
                            this[method](params[prop]);
                          }
                          
                      }
                  }

              }

              setLabel(str){
                this.generic.name = str;
              }


            
                
              setId(id){
                  this.id = id;
                  this.generic.id = id;
            }

            setAccount_id(a){
              this.account_id = a;
            }
            setTracking_number(val){
              this.tracking_number = val;
            }

            setPlatformId(id){
              this.platformId = id;
              this.generic.platformId = id;
            }
            

              setOriginAccountId(id){
                this.originAccountId = id;
                this.generic.originAccountId = id;
              }
              setOriginId(id){
                this.originId = id;
                this.generic.originId = id;
              }
              

              
            setTruncate(obj){
              if (obj){
              this.truncate = obj;
              this.filtered = (obj && obj[this.accountType] && (obj[this.accountType].indexOf(this.id) > -1)) ? false : true;
              }
            }
            
          
          setModelParameters(params){
            this.filtered = false;
              this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
              this[params.accountType].push(params);
          }
        }
        export default Calltrackingmetrics;
                  